import React from "react";
import ItemList from "../components/ItemList";

function Tarrinas() {
  const IMG_TARRINA =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIexVcRzG6ygDqp5GTMLxlI21DFk_z8z1j7aDQY88auptk1PPQvD0UZghmEr3H0MhUrFY&usqp=CAU";

  const BASE_DESC = "Patata con carne (kebab o pollo)";
  const MENU_INCLUDES = "Extra de carne + 1 bebida";

  const tarrinaList = [
    {
      key: "tarrina-peq",
      name: "Tarrina Pequeña",
      normal: "4,50€",
      huevo: "5,00€",
      menuPrice: "6,00€",
    },
    {
      key: "tarrina-med",
      name: "Tarrina Mediana",
      normal: "5,00€",
      huevo: "5,50€",
      menuPrice: "7,00€",
    },
    {
      key: "tarrina-gra",
      name: "Tarrina Grande",
      normal: "6,00€",
      huevo: "6,50€",
      menuPrice: "8,00€",
    },
    {
      key: "tarrina-extra",
      name: "Tarrina Extra",
      normal: "8,00€",
      huevo: "8,50€",
      menuPrice: null,
    },
  ].map((t) => ({
    ...t,
    img: IMG_TARRINA,
    price: t.normal,
    description: BASE_DESC,
    extra: `+ huevo ${t.huevo}`,   // 👈 EXTRA destacado
    menuIncludes: t.menuPrice ? MENU_INCLUDES : null,
  }));
  return (
    <div id="tarrinas" className="container mx-auto mt-8 px-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Tarrinas</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tarrinaList.map((item) => (
          <ItemList
            key={item.key}
            name={item.name}
            description={item.description}
            price={item.price}
            img={item.img}
            menuPrice={item.menuPrice}
            menuIncludes={item.menuIncludes}
            extra={item.extra}
          />
        ))}
      </div>
    </div>
  );
}

export default Tarrinas;